import { createGlobalStyle } from "styled-components";
import "normalize.css";
import { theme } from "./theme";
import { device } from "./util/media-query";
import { size } from "./util/size";
import { pseudo } from "./util/pseudo";

export const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 62.5%;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
    height: 100%;
  }

  body {
    font-size: 1.6rem;
    font-family: ${theme.fonts.body};
    color: ${theme.colors.offWhite};
    background-color: ${theme.colors.black};
    height: 100%;
    margin: 0;
    margin-top: 0 !important;
  }

  #___gatsby,
  #gatsby-focus-wrapper,
  main {
    min-height: 100%;
  }

  a {
    color: currentColor;
    display: block;
    text-decoration: none;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    outline: none;
  }

  img {
    display: block;
    height: auto;
    width: 100%;
  }

  figure {
    margin: 0;
  }

  input,
  select {
    border: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }

  ol,
  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
  }

  h1, h2, h3, h4, h5{
    font-weight: 400;
    margin: 0;
  }
  /*
  svg {
    fill: currentColor;
    height: 100%;
    width: 100%;
  }
  */

  .is-draggable {
    cursor: grab;
  }

  .is-dragging {
    cursor: grabbing;
  }

  .disable-scroll {
    overflow: hidden;
  }

  /* hide riotbar except .riotbar-locale-switcher and .riotbar-legal-links */
  .riotbar-header-wrapper {
    position: fixed !important;
    pointer-events: none;
    max-width: 100%;

    @media ${device.desktop} {
      position: absolute !important;
    }

    .riotbar-header {
      justify-content: flex-end;
      background-color: transparent;
      border-bottom: 0;
    }

    .riotbar-left-content,
    .riotbar-center-content,
    .riotbar-mobile-nav-reset,
    .riotbar-account-container{
      display: none;
    }

    .riotbar-right-content {
      margin-right: 4rem;

      .lang-switch-trigger,
      .locale-switcher-dropdown {
        pointer-events: auto;
      }

      .locale-switcher-dropdown {
        left: auto;
        right: 0.6rem;
      }

      .lang-switch-caret {
        left: auto;
        right: 2rem;
      }

      @media ${device.desktop} {
        margin-right: 0;
        margin-top: 6.3vh;

        .riotbar-locale-switcher {
          display: block;
        }

        .locale-switcher-icon {
          ${size("3.2rem")};
          position: relative;
        }

        .lang-switch-trigger {
          ${size("100%")};

          svg {
            ${size("1.6rem")};
            top: 0.8rem;
            left: 0.8rem;
          }
        }

        .locale-switcher-dropdown {
          right: -1.5rem;
        }
      }

      @media ${device.desktopL} {
        margin-top: 6.8vh;
      }
    }
  }

  .riotbar-footer {
    .is-garena & {
      display: none;
    }

    .riotbar-footer-content {
      padding-bottom: 3rem;

      > div:not(.riotbar-legal-links) {
        display: none;
      }

      .riotbar-legal-links {
        font-family: ${theme.fonts.body};
        padding-bottom: 1rem;

        li {
          margin: 0;
        }

        a {
          position: relative;
          color: ${theme.colors.magenta};
          border-radius: 0;

          &::before {
            ${pseudo()};
            width: calc(100% - 3.2rem);
            bottom: 0.5rem;
            border-bottom: 0.1rem solid;
            opacity: 0;
          }

          &:hover {
            background-color: transparent;

            &::before {
              opacity: 1;
              transition: opacity 0.3s;
            }
          }
        }
      }
    }

    p.copyright {
      font-family: ${theme.fonts.body};
      opacity: 0.5;
    }
  }

  [lang="ko-kr"] {
    word-break: keep-all;
  }
`;
